<template>
  <div class="tw:flex tw:items-center">
    <p class="tw:text-xl tw:font-bold"><slot /></p>
    <UiTooltip tooltip-position="top" :label="$t(tooltipLabel)" class="tw:cursor-pointer tw:ml-1">
      <InformationOutline class="tw:fill-none tw:stroke-gray-800 tw:h-[18px] tw:w-[18px]" />
    </UiTooltip>
  </div>
</template>

<script setup>
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'

defineProps({
  tooltipLabel: {
    type: String,
    required: true,
    default: '',
  },
})
</script>
